import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ pendingReviews = 0, className = '' }) => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Upload Invoices',
      description: 'Start new batch processing',
      icon: 'Upload',
      variant: 'default',
      onClick: () => navigate('/uploads')
    },
    {
      label: `Review Queue ${pendingReviews > 0 ? `(${pendingReviews})` : ''}`,
      description: 'Process pending invoices',
      icon: 'Eye',
      variant: pendingReviews > 0 ? 'warning' : 'outline',
      onClick: () => navigate('/invoices?status=needs_review')
    },
    {
      label: 'View Calendar',
      description: 'Historical processing',
      icon: 'Calendar',
      variant: 'outline',
      onClick: () => navigate('/calendar-view')
    },
    {
      label: 'Export History',
      description: 'Download previous exports',
      icon: 'Download',
      variant: 'outline',
      onClick: () => navigate('/export-history')
    }
  ];

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action, index) => (
          <div key={index} className="group">
            <Button
              variant={action?.variant}
              onClick={action?.onClick}
              iconName={action?.icon}
              iconPosition="left"
              fullWidth
              className="justify-start h-auto p-4"
            >
              <div className="text-left">
                <div className="font-medium">{action?.label}</div>
                <div className="text-xs opacity-80 mt-1">{action?.description}</div>
              </div>
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
